<template>
	<div>
		<div class="container">
			<div class="step">
				<van-steps :active="active">
					<van-step>确认用户及卡口</van-step>
					<van-step>扫码药品条码</van-step>
					<van-step>上传处方证明</van-step>
				</van-steps>
			</div>
			<div class="box3-view5">
				<div class="isClassified">选择类型</div>
				<van-radio-group v-model="prescription_type"  class="radio-group">
				  <van-radio class="radio-group1" name="1">处方药</van-radio>
				  <van-radio class="radio-group1" name="0">非处方药</van-radio>
				</van-radio-group>
				
			</div>
			<div class="box3-view6" v-if="prescription_type == '1'">
				<div class="file_view">
					<van-uploader  v-model="fileList"
					:multiple="true" 
						:after-read="afterRead" capture="camera" accept="image/*" />
				</div>
			</div>
		</div>

		<div class="submit_div">
			<div class="nextbutton">
				<button class="submit_btn" @click="prew()">上一步</button>
			</div>
			<div class="nextbutton">
				<button class="submit_btn" style="background-color: #3eb575" @click="add">提交</button>
			</div>
		</div>

		<div class="footer-Main">
			<div class="footer-Main-title">注意：</div>
			<div>步骤一：请选择药店卡口，并确认用户信息。用户信息可通过上传身份证或扫描东楚码来确认</div>
			<div>步骤二：通过手机扫码所有购买的药品</div>
			<div>步骤三：请上传医院处方证明</div>
		</div>

	</div>
</template>

<script>
	import {sileiyaoupload,medicineControl} from "@/api/index.js"
	import {
		Toast
	} from 'vant';
	export default {
		name: "index",
		data() {
			return {
				imageList: [],
				active: 2,
				prescription_type: 0, // 处方证明的方式
				steps: [{
					title: '确认用户及卡口'
				}, {
					title: '扫描药品条码'
				}, {
					title: '上传处方证明'
				}],
				fileList:[]
			}
		},
		methods: {
			valid() {
				let msg = '';
				if (this.imageList.length == 0) {
					msg = '请上传医嘱证明'
				}
				return msg;
			},
			add() {
				if (this.prescription_type == 1) {
					let msg = this.valid();
					if (msg) {
						Toast.fail(msg)
					} else {
						// 1.保存本页面缓存
						let obj = {}
						obj.yzImgList = this.imageList
						localStorage.setItem('gyStepThree', JSON.stringify(obj))
						// 2.提交最终数据
						this.preSubmit();
						
					}
				} else {
					// 提交最终数据
					this.preSubmit();
					
				}
			},
			async medicineControl(obj){
				let params=obj
				let res=await medicineControl(params)
				console.log('res',res)
				// 1.清空缓存
				localStorage.removeItem('gyStepOne')
				localStorage.removeItem('gyStepTwo')
				localStorage.removeItem('gyStepThree')
				// 2.跳转页面
				Toast('提交成功')
				let that=this
				setTimeout(function() {
					that.$router.push('yaoguanIndex')
				}, 1000)
			},
			preSubmit() {
				let stepOne = JSON.parse(localStorage.getItem('gyStepOne'))
				let stepTwo = JSON.parse(localStorage.getItem('gyStepTwo'))
				let result = {
					gmlx: '',
					gmr_dh: '',
					dgr_dh: '',
					dgr_name: '',
					door_id: '',
					idcard_images_url: '',
					member_id: '',
					medicine_attr: '',
					prescription_images_url: '',
					prescription_type: ''
				}
				result.isback = stepOne.isback;
				result.iscatch = stepOne.iscatch;
				result.zz = stepOne.zz;
				result.gmlx = stepOne.gy_type;
				result.gmr_dh = stepOne.gmr_dh
				result.dgr_dh = stepOne.dgr_dh
				result.dgr_name = stepOne.dgr_name
				result.gyrczdq = stepOne.gyrczdq;
				result.gyrczdjd = stepOne.gyrczdjd;
				result.gyrczdsq = stepOne.gyrczdsq;
				result.door_id = stepOne.kakouId
				result.medicine_attr = JSON.stringify(stepTwo.ypList)
				let prescriptionType = this.prescription_type
				if (prescriptionType == 1) {
					let stepThree = JSON.parse(localStorage.getItem('gyStepThree'))
					result.prescription_images_url = JSON.stringify(stepThree.yzImgList)
				}
				result.prescription_type = this.prescription_type; 

				if (stepOne.userType == 1) {
					result.gmr_name = stepOne.gmr_name;
					result.gmrsfzh = stepOne.gmrsfzh;
				}
				if (stepOne.userType == 2) {
					result.member_id = stepOne.member_id
					result.gmrsfzh = stepOne.idcard;
				}
				Toast('数据提交中...')
				this.medicineControl(result)				
			},
			//上传回调
			afterRead(file, details) {
				// 此时可以自行将文件上传至服务器
				this.sileiyaoupload(file.file)
			},
			//上传图片
			async sileiyaoupload(src) {
				const formData = new FormData();
				// 通过append方法添加需要的file
				// 这里需要注意 append(key, value)来添加数据，如果指定的key不存在则会新增一条数据，如果key存在，则添加到数据的末尾
				formData.append('uploadFile', src)
				let res = await sileiyaoupload(formData)
				if (res.code == 0) {
					this.imageList.push(res.result)
				} else {
					Toast.fail(res.msg)
				}			
			},			
			//上一步
			prew() {
				this.$router.push({
					path: '/yaoguanAddtwo',
					query: {
						ultraType: 3,
					}
				})
			},

		}
	}
</script>

<style scoped>
	.container {
		position: relative;
		font-size: 16px;
	}

	.status-btn {
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		flex-direction: row;
		align-items: center;
		justify-content: center;
		height: 46px;
		margin: 15px;
		background-color: #007AFF;
	}

	.example-body {
		/* #ifndef APP-NVUE */
		display: block;
		/* #endif */
		padding: 15px;
		flex-direction: row;
	}

	.box3-view6 {
		width: 96%;
		padding: 10px 0;
		margin: auto;
		overflow: hidden;
		border-bottom: 1px solid rgba(238, 238, 238, 1);
		display: flex;
	}

	.box3-view6-list {
		width: 75px;
		height: 75px;
		float: left;
		margin: 8px;
	}

	.box3-view6-list>image {
		width: 100%;
		height: 100%;
	}

	.submit_div {
		text-align: center;
		margin-top: 40px;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
	}

	.submit_div .nextbutton {
		flex: 1;
	}

	.submit_btn {
		width: 80%;
		height: 50px;
		background-color: #4293F4;
		color: #FFFFFF;
		font-size: 18px;
		border-radius: 5px;
	}

	.footer-Main {
		font-size: 12px;
		margin: 20px;
		padding: 10px;
		color: rgb(153, 153, 153);
		background-color: #f2f2f2;
	}

	.footer-Main-title {
		font-size: 18px;
	}

	.footer-Main>div {
		margin: 5px;
		color: rgb(153, 153, 153);
	}

	.box3-view5 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 96%;
		margin: auto;
		height: 55px;
		border-bottom: 1px solid rgba(238, 238, 238, 1);
	}

	.box3-view>view:nth-of-type(1),
	.isClassified {
		width: 95px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(64, 64, 66, 1);
		text-align: center;
	}

	.box3-view5 {
		justify-content: flex-start;
	}

	.radio-group {
		font-size: 16px;
		margin-left: 10px;
		display: flex;
		align-items: center;
	}
	.radio-group1{
		margin-right: 25px;
	}
	.van-uploader__upload{
		margom:0 !important;
	}
	.van-uploader__input{
		width: 100%;
		height: 100%;
	}
</style>
